import React from 'react';
import { Button, useNotify, refreshView, useCreate } from 'react-admin';
import IconCheckBox from '@material-ui/icons/CheckBox';
import { useDispatch } from 'react-redux';

const ConfirmInvoiceButton = ({ record }) => {
	const notify = useNotify();
	const dispatch = useDispatch();
	const [confirmInvoice] = useCreate('invoices');

	const handleClick = () => {
		confirmInvoice(
			{
				payload: {
					id: record.id,
					method: 'confirm',
				},
			},
			{
				onSuccess: () => {
					notify('resources.invoices.notifications.confirmed');
					dispatch(refreshView());
				},
				onFailure: (error) => {
					notify(error.message, 'error');
				},
			},
		);
	};

	return (
		<Button
			onClick={handleClick}
			label="resources.invoices.labels.confirmButton"
			variant="contained"
			disabled={!record || record.invoiceStatus !== 'Created'}
		>
			<IconCheckBox />
		</Button>
	);
};

export default ConfirmInvoiceButton;
